<form #form='ngForm' (ngSubmit)="onSubmit(form)">
  <ejs-richtexteditor id='iframeRTE' [(value)]='texteditor' [toolbarSettings]='tools' name="texteditor" [(ngModel)]="texteditor"></ejs-richtexteditor>
  <button type="submit" class="btn btn-info" style="margin-top:15px;">Submit</button>
</form>